import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function HelpBodyUserAssignment() {
    return (
        <OnboardingBody title='What is a user assignment?'>
            <div>
                <p>
                    You can assign leads to your team at any time during your sales process. Some
                    businesses reassign to regional teams after qualification — others assign
                    round-robin at the beginning, and a single rep owns the lead to the sale.
                </p>
            </div>
        </OnboardingBody>
    );
}
